import React from 'react';
import Plot from 'react-plotly.js';
import Alert from '@mui/material/Alert';

const MissingValuesHistogram = ({ data }) => {
  const total = Object.values(data).reduce((total, value) => total + value, 0);

  if (total === 0) {
    return (
      <Alert severity="info" style={{ fontSize: "18px", width: "40%", marginLeft: "20%", marginTop: '8rem', borderRadius: '12px', backgroundColor: "#E8E8E8" }}>
        There is no missing data in the file.
      </Alert>
    )
  }

  if (!data) {
    return (<div>Graph is Missing !!!</div>)
  }

  // Convert the data object to an array of key-value pairs
  const dataArray = Object.entries(data);

  // Sort the array based on the values (descending order)
  dataArray.sort((a, b) => b[1] - a[1]);

  // Convert the sorted array back to separate labels and values arrays
  const labels = dataArray.map(item => item[0]);
  const values = dataArray.map(item => item[1]);

  const containerStyle = {
    display: 'flex',
    justifyContent: 'start',
    overflowX: 'scroll',
    overflowY: 'auto',
    width: '100%',
    height: '440px',
    padding: '4px',
    boxSizing: 'border-box'
  };

  const plotStyle = {
    minWidth: `${labels.length * 40}px`,
    height: '100%'
  };

  return (
    <div style={containerStyle}>
      <Plot
        data={[
          {
            type: 'bar',
            x: labels,
            y: values,
            marker: {
              color: 'navy'
            },
            hoverinfo: 'x+y'
          }
        ]}
        layout={{
          autosize: true,
          title: '<b>Missing Values Graph</b>',
          xaxis: {
            title: 'Features',
            tickangle: -45,
            automargin: true
          },
          yaxis: {
            title: 'Missing Values Count'
          },
          margin: {
            b: 150
          }
        }}
        useResizeHandler={true}
        style={plotStyle}
        config={{
          scrollZoom: true,
          responsive: true
        }}
      />
    </div>
  );
};

export default MissingValuesHistogram;
